module.exports = __webpack_public_path__ + "img/easter_tour_mini_cover_1-1.cf39ff42.png";